import { render, staticRenderFns } from "./QueriedPagination.vue?vue&type=template&id=3616fd4e&scoped=true&"
import script from "./QueriedPagination.vue?vue&type=script&lang=js&"
export * from "./QueriedPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3616fd4e",
  null
  
)

export default component.exports